import React from 'react';
import { Button, Typography } from "@mui/material";
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice';
import {PageContainer} from "../../survey-tools/ui-components/containers"

const Instructions = ({ dispatch }) => {
    const handleStart = () => {
    console.log("Dispatching nextTask from Instructions");
    dispatch(nextTask({}));
};

    return (
        <PageContainer>
        <div>
            <Typography gutterBottom>Now, we will ask you to reflect on your current mental state.</Typography>
            <Button variant="contained" onClick={handleStart}>Next</Button>
        </div>
        </PageContainer>
    );
};

export default connect()(Instructions);
